"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/*
  The MIT License

  Copyright (c) 2017-2019 EclipseSource Munich
  https://github.com/eclipsesource/jsonforms

  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in
  all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
  THE SOFTWARE.
*/
var range_1 = tslib_1.__importDefault(require("lodash/range"));
var react_1 = tslib_1.__importStar(require("react"));
var core_1 = require("@jsonforms/core");
var react_2 = require("@jsonforms/react");
exports.ArrayControl = function (_a) {
    var classNames = _a.classNames, data = _a.data, label = _a.label, path = _a.path, schema = _a.schema, addItem = _a.addItem, uischema = _a.uischema, uischemas = _a.uischemas, renderers = _a.renderers;
    var childUiSchema = react_1.useMemo(function () { return core_1.findUISchema(uischemas, schema, uischema.scope, path); }, [uischemas, schema, uischema.scope, path]);
    return (react_1.default.createElement("div", { className: classNames.wrapper },
        react_1.default.createElement("fieldset", { className: classNames.fieldSet },
            react_1.default.createElement("legend", null,
                react_1.default.createElement("button", { className: classNames.button, onClick: function () { return addItem(path, core_1.createDefaultValue(schema)); } }, "+"),
                react_1.default.createElement("label", { className: 'array.label' }, label)),
            react_1.default.createElement("div", { className: classNames.children }, data ? (range_1.default(0, data.length).map(function (index) {
                var childPath = core_1.composePaths(path, "" + index);
                return (react_1.default.createElement(react_2.ResolvedJsonFormsDispatch, { schema: schema, uischema: childUiSchema || uischema, path: childPath, key: childPath, renderers: renderers }));
            })) : (react_1.default.createElement("p", null, "No data"))))));
};
//# sourceMappingURL=ArrayControl.js.map